import { useState, useEffect, memo } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { X, Sparkles, ArrowRight, Users, Shield, Clock } from "lucide-react";
import { Link } from "react-router-dom";

export const StickyBottomCTA = memo(() => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if already dismissed this session
    const dismissed = sessionStorage.getItem("sticky-cta-dismissed");
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    const handleScroll = () => {
      // Show after scrolling 400px
      if (window.scrollY > 400) {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem("sticky-cta-dismissed", "true");
  };

  if (isDismissed || !isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-500">
      {/* Gradient border top */}
      <div className="h-1 bg-gradient-to-r from-primary via-accent to-primary" />
      
      <div className="bg-background/95 backdrop-blur-md border-t shadow-2xl">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            {/* Left: Value proposition */}
            <div className="flex items-center gap-4 flex-1 min-w-0">
              <Badge className="bg-primary text-primary-foreground animate-pulse hidden sm:flex">
                <Sparkles className="w-3 h-3 mr-1" />
                90 días gratis
              </Badge>
              
              <div className="flex items-center gap-3 text-sm">
                <span className="flex items-center gap-1 text-muted-foreground">
                  <Shield className="w-4 h-4 text-green-500" />
                  <span className="hidden md:inline">Sin tarjeta</span>
                </span>
                <span className="flex items-center gap-1 text-muted-foreground">
                  <Users className="w-4 h-4 text-primary" />
                  <span className="hidden md:inline">+2,500 profesionales</span>
                </span>
                <span className="flex items-center gap-1 text-muted-foreground">
                  <Clock className="w-4 h-4 text-amber-500" />
                  <span className="hidden lg:inline">Activa en 2 min</span>
                </span>
              </div>
            </div>

            {/* Right: CTAs */}
            <div className="flex items-center gap-3">
              <Link to="/become-trainer">
                <Button size="lg" className="bg-gradient-primary hover:opacity-90 shadow-lg">
                  Empezar Gratis
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
              
              <Button
                onClick={handleDismiss}
                variant="ghost"
                size="icon"
                className="h-9 w-9"
                aria-label="Cerrar banner promocional"
              >
                <X className="w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

StickyBottomCTA.displayName = "StickyBottomCTA";
